<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Backstory</h1>
          <p>Form Factory, formerly Gesundheit Foods, wanted to redesign their corporate website to give clients and investors and clear picture of their capabilities. My role on this project was to update the company’s branding, including creation of a new company logo, and to design the UI of the site following a UX exploration.</p>
        </project-text>

        <project-video
        size="75"
        videoID="350344466"
        :gif="true"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>All About the User</h1>
          <p>Like all web projects, I started by thinking about the user. First, I established 3 personas of the users most likely to visit the Form Factory website: investors, clients, and press members. Before doing any wireframing, I had a goal in place to ensure that each of these users could accomplish their goals quickly by laying out navigation and internal links in a simple to understand way.<br><br>I created a document to send to Form Factory which included a summary of these personas and user goals, as well as wireframes, mood boards, and design explorations.</p>
        </project-text>

        <project-carousel
        size="75"
        :color="$store.state.activeProject.color">
          <slide><img v-lazy="'/img/p/formfactory/uxdocument1.jpg'" alt="Form Factory UX Document - Personas and Tasks"></slide>
          <slide><img v-lazy="'/img/p/formfactory/uxdocument2.jpg'" alt="Form Factory UX Document - Wireframes"></slide>
          <slide><img v-lazy="'/img/p/formfactory/uxdocument3.jpg'" alt="Form Factory UX Document - Wireframes"></slide>
          <slide><img v-lazy="'/img/p/formfactory/uxdocument4.jpg'" alt="Form Factory UX Document - Moodboards"></slide>
        </project-carousel>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>A Visual Refresh</h1>
          <p>Next, once Form Factory chose a visual direction, I was tasked with revamping their logo. I liked the concept of a rotated ‘F’ being a factory, but wanted to make that more subtle and give the logo a more modern feel. After a couple rounds we were able to reach a consensus on a mix of the wordmark from their original logo, and a sleeker version of the factory F. I also created a style guide during this stage, which continued to evolve over the design process.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/formfactory/logos.jpg"
        alt="Form Factory Logo Process"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Making It Work</h1>
          <p>I then moved onto the final stage of the project: creating several high fidelity page mockups and turning them into a working prototype of the website. The prototype in its current form contains Home, About, Capabilities, Careers, and Contact pages. The site is set to be developed at a later stage.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/formfactory/artboards.jpg"
        alt="Components and Artboards"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'
import ProjectVideo from '../../components/project/ProjectVideo.vue'
import ProjectCarousel from '../../components/project/ProjectCarousel.vue'
import { Slide } from 'vue-carousel'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage, ProjectVideo, ProjectCarousel, Slide }
}
</script>

<style lang="scss" scoped>

</style>
